import { CustomElement } from "../../../core/CustomElement";
import "../field/field";
import { CCCField } from "../field/field";
import TextInputVM from "./viewModel";

export class CCCInputText extends CustomElement {
  // eslint-disable-next-line
  state: Object = { foo: "bar" };
  container: HTMLElement = null;
  viewModel: TextInputVM;
  $cccField: CCCField;

  static get observedAttributes(): Array<string> {
    return [
      "type",
      "placeholder",
      "label",
      "label-edge",
      "label-width",
      "label-align",
      "maxlength",
      "readonly",
      "disabled",
      "internal-loading",
      "message",
    ];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
      viewModel: require("./viewModel"),
    };
    this.setupComponent();
    this.$cccField = this.shadowDom.querySelector("ccc-field");
    //this.setLoading(true);
  }
  // eslint-disable-next-line
  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ) {
    if (attr === "type") {
      this.viewModel.type(newValue);
    }
    if (attr === "placeholder") {
      this.viewModel.placeholder(newValue);
    }
    if (attr === "label" && this.$cccField) {
      this.$cccField.label = newValue;
    }
    if (attr === "label-edge" && this.$cccField) {
      this.$cccField.setAttribute("label-edge", newValue);
    }
    if (attr === "label-width" && this.$cccField) {
      this.$cccField.setAttribute("label-width", newValue);
    }
    if (attr === "label-align" && this.$cccField) {
      this.$cccField.setAttribute("label-align", newValue);
    }
    if (attr === "maxlength") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        $input.removeAttribute("maxlength");
      } else {
        $input.setAttribute("maxlength", newValue);
      }
    }
    if (attr === "readonly") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        $input.removeAttribute("readonly");
      } else {
        $input.setAttribute("readonly", "");
      }
    }
    if (attr === "disabled") {
      const $input = this.shadowDom.querySelector("input");
      if (newValue === null) {
        $input.removeAttribute("disabled");
        if (this.$cccField) {
          this.$cccField.removeAttribute("disabled");
        }
      } else {
        $input.setAttribute("disabled", "");
        if (this.$cccField) {
          this.$cccField.setAttribute("disabled", "");
        }
      }
    }
    if (attr === "internal-loading" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("internal-loading");
      } else {
        this.$cccField.setAttribute("internal-loading", newValue);
      }
    }
    if (attr === "message" && this.$cccField) {
      if (newValue === null) {
        this.$cccField.removeAttribute("message");
      } else {
        this.$cccField.setAttribute("message", newValue);
      }
    }
  }

  // eslint-disable-next-line
  subscribeToVal(instant: boolean, fn: Function) {
    if (instant) {
      this.viewModel.subscribeToInstantValue(fn);
    } else {
      this.viewModel.subscribeToTetheredValue(fn);
    }
  }

  subscribeToValueUpdated(fn: (value: string) => void): void {
    this.viewModel.subscribeToValue(fn);
  }

  applyLowercaseExtend(): void {
    this.viewModel.applyLowercaseExtend();
  }

  applyUppercaseExtend(): void {
    this.viewModel.applyUppercaseExtend();
  }

  // eslint-disable-next-line
  onFocus(fn: Function) {
    this.viewModel.subscribeToFocus(fn);
  }
  // eslint-disable-next-line
  getValue() {
    return this.viewModel.instantVal();
  }
  // eslint-disable-next-line
  setValue(val: string) {
    return this.viewModel.instantVal(val);
  }
}

// define component
if (!customElements.get("ccc-input-text")) {
  customElements.define("ccc-input-text", CCCInputText);
}
